import { render, staticRenderFns } from "./Bankers.vue?vue&type=template&id=3a0d52d6"
import script from "./Bankers.vue?vue&type=script&lang=js"
export * from "./Bankers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports